import { useMutation, useQueryClient } from '@tanstack/react-query'

import { API_BASE_URL } from '../constants.ts'

import { httpClient } from '@/shared/utils/http-client.ts'

export const useDeleteScoutMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (uuid: string) => {
      const response = await httpClient.fetch(`${API_BASE_URL}/scout/${uuid}`, {
        method: 'DELETE',
      })

      if (!response.ok) {
        if (response.status === 400) {
          const errorData = await response.json()
          throw new Error((errorData.error as string) || 'Scout ID is required')
        }
        throw new Error('Failed to delete scout')
      }

      // 204 No Content response has no body to return
      return null
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['scouts'] })
    },
  })
}
